let itm = {
  bcg: require('./bcg_units.png'),
  animals: require('./bcg_anim_t.png'),
  items: [
    {
      bcg: require('./01.png'),
      cssStyle: {
        position: 'absolute',
        top: '30%',
        left: '3%',
        width: '17.6%',
      },
      // disable: true,
      items: require(`./u1/unit1.js`).default,
      redirect: '1',
      type: 'unit',
    },
    {
      bcg: require('./02.png'),
      cssStyle: {
        position: 'absolute',
        top: '30%',
        left: '20%',
        width: '17.6%',
      },
      // disable: true,
      items: require(`./u2/unit2.js`).default,
      redirect: '2',
      type: 'unit',
    },
    {
      bcg: require('./03.png'),
      cssStyle: {
        position: 'absolute',
        top: '30%',
        left: '37%',
        width: '17.6%',
      },
      // disable: true,
      items: require(`./u3/unit3.js`).default,
      redirect: '3',
      type: 'unit',
    },
    {
      bcg: require('./04.png'),
      cssStyle: {
        position: 'absolute',
        top: '30%',
        left: '54%',
        width: '17.6%',
      },
      // disable: true,
      items: require(`./u4/unit4.js`).default,
      redirect: '4',
      type: 'unit',
    },
    {
      bcg: require('./05.png'),
      cssStyle: {
        position: 'absolute',
        top: '30%',
        left: '71%',
        width: '17.6%',
      },
      // disable: true,
      items: require(`./u5/unit5.js`).default,
      redirect: '5',
      type: 'unit',
    },
    //
    {
      bcg: require('./06.png'),
      cssStyle: {
        position: 'absolute',
        top: '53%',
        left: '13%',
        width: '17.6%',
      },
      // disable: true,
      items: require(`./u6/unit6.js`).default,
      redirect: '6',
      type: 'unit',
    },
    {
      bcg: require('./07.png'),
      cssStyle: {
        position: 'absolute',
        top: '53%',
        left: '30%',
        width: '17.6%',
      },
      // disable: true,
      items: require(`./u7/unit7.js`).default,
      redirect: '7',
      type: 'unit',
    },
    {
      bcg: require('./08.png'),
      cssStyle: {
        position: 'absolute',
        top: '53%',
        left: '47%',
        width: '17.6%',
      },
      // disable: true,
      items: require(`./u8/unit8.js`).default,
      redirect: '8',
      type: 'unit',
    },
    {
      bcg: require('./09.png'),
      cssStyle: {
        position: 'absolute',
        top: '53%',
        left: '64%',
        width: '17.6%',
      },
      // disable: true,
      items: require(`./u9/unit9.js`).default,
      redirect: '9',
      type: 'unit',
    },
    {
      bcg: require('./10.png'),
      cssStyle: {
        position: 'absolute',
        top: '53%',
        left: '81%',
        width: '17.6%',
      },
      // disable: true,
      items: require(`./u10/unit10.js`).default,
      redirect: '10',
      type: 'unit',
    },
  ],
};

export default itm;
